import React, { useState } from 'react'
import {
  Col, Upload, Row, Input, Checkbox, DatePicker, Select, AutoComplete,
} from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import moment from 'moment'
import { useQuery } from '@apollo/react-hooks'
import {
  TIRE_SERIAL_NUMBER_LIST, TIRE_PATCH_TYPE_LIST,
} from '../../../constants/graph/query'
import {
  DRIVER_LIST, GET_TIRE_PATCH_SHOP_LIST, GET_TRAILER_LIST, GET_TRUCK_LIST,
} from '../../../constants/graphql/query'
import { AddTirePatchStoreModal } from '../../../components/tire-patch-components'
import {
  detailMode, TIRE_PATCH_TYPE, STATUSTEXTSELECTOR, STATUSCOLORSELECTOR,
} from '../constants'
import { checkFloat } from '../../../utils/util-services'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Upload box
5: Select
6: TextArea
7: Upload
*/

const CreateMode = ({
  data, mutationVariables, onChangeHandler, tireInfoData, setTireInfoId, setPatchDate, tirePatchStore, setTirePatchStore,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              onChange: e => onChangeHandler(data.id, e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'price' && !checkFloat(e)) {
                  e.preventDefault()
                }
              },
              type: data.id === 'price' ? 'number' : 'text',
              step: data.id === 'price' ? '0.01' : undefined,
              min: '0',
              ...data.props.input,
            }}
          />
        </Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 3.1: {
      const {
        loading: tireLoading, data: tireData, error: tireError, refetch: tireRefetch,
      } = useQuery(TIRE_SERIAL_NUMBER_LIST)
      if (tireLoading && _.isEmpty(tireData)) return <UI.Loading />
      if (tireError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              style={{ width: '100%' }}
              loading={tireLoading}
              filterOption={(input, option) => option.props.serialNumber.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
                setTireInfoId(`${e}`)
                // tireInfoRefetch({ id: `${e}` })
              }}
              onSearch={e => tireRefetch({ serialNumber: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                tireData.TireSerialNumberList.lists.map(v => <Select.Option key={v.id} value={v.id} serialNumber={v.serialNumber}>{v.serialNumber}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 3.2: {
      const {
        loading: driverLoading, data: driverData, error: driverError, refetch: driverRefetch,
      } = useQuery(DRIVER_LIST)
      if (driverLoading && _.isEmpty(driverData)) return <UI.Loading />
      if (driverError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              style={{ width: '100%' }}
              loading={driverLoading}
              filterOption={(input, option) => option.props.fullname.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              onSearch={e => driverRefetch({ fullname: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                driverData.DriverList.lists.map(v => <Select.Option key={v.id} value={v.id} fullname={v.fullname}>{v.fullname}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 3.3: {
      const {
        loading: patchTypeLoading, data: patchTypeData, error: patchTypeError, refetch: patchTypeRefetch,
      } = useQuery(TIRE_PATCH_TYPE_LIST)
      if (patchTypeLoading && _.isEmpty(patchTypeData)) return <UI.Loading />
      if (patchTypeError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <AutoComplete
              {...data.props}
              dataSource={patchTypeData.TirePatchLogTypeList.data}
              style={{ width: '100%' }}
              onSelect={e => onChangeHandler(data.id, e)}
              onSearch={e => onChangeHandler(data.id, e)}
            />
          </UI.Div>
        </Col>
      )
    }
    case 3.4: {
      const [addTirePatchStoreModal, setAddTirePatchStoreModal] = useState(false)
      const {
        loading: tirePatchStoreLoading, data: tirePatchStoreData, error: tirePatchStoreError, refetch: tirePatchStoreRefetch,
      } = useQuery(GET_TIRE_PATCH_SHOP_LIST)
      if (tirePatchStoreLoading && _.isEmpty(tirePatchStoreData)) return <Col span={data.span} offset={data.offset}><UI.Loading /></Col>
      if (tirePatchStoreError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.Div display='flex'>
              <Select
                showSearch
                style={{ width: '70%' }}
                loading={tirePatchStoreLoading}
                filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onSelect={(e) => {
                  onChangeHandler(data.id, e)
                  setTirePatchStore(_.find(tirePatchStoreData.TirePatchStoreList.lists, o => o.id === e))
                }}
                onSearch={e => tirePatchStoreRefetch({ name: e })}
                placeholder='พิมพ์เพื่อค้นหา'
              >
                {
                  tirePatchStoreData.TirePatchStoreList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
                }
              </Select>
              <UI.Button
                margin='-10px 0 0 16px'
                text={'เพิ่มร้านปะยาง'}
                icon={'fas fa-plus'}
                onClick={() => setAddTirePatchStoreModal(true)}
              />
            </UI.Div>
            <AddTirePatchStoreModal addTirePatchStoreModal={addTirePatchStoreModal} setAddTirePatchStoreModal={setAddTirePatchStoreModal} />
          </UI.Div>
        </Col>
      )
    }
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 7:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker onChange={(e) => {
              onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))
              setPatchDate(e)
            }} style={{ marginBottom: 16 }} />
          </UI.Div>
        </Col>
      )
    case 11:
    case 12:
    case 17:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
          </UI.Div>
        </Col>
      )
    case 13: {
      const {
        loading: truckLoading, data: truckData, refetch: truckRefetch,
      } = useQuery(GET_TRUCK_LIST)
      const {
        loading: trailerLoading, data: trailerData, error: trailerError, refetch: trailerRefetch,
      } = useQuery(GET_TRAILER_LIST)
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0' bold>{data.label}</UI.P>
            {!_.isEmpty(tireInfoData)
              && <UI.Div>
                <UI.Div display='flex' flexDirection='row'>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ชื่อ</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.inventoryOption.inventory.productName}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ยี่ห้อ</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.inventoryOption.inventory.brand}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ประเภทยาง</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.Tire.TireType.name}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >รุ่น</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.inventoryOption.variantName}</UI.P>
                    </UI.Div>
                  </Col>
                </UI.Div>
                <UI.Div display='flex' flexDirection='row'>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ทะเบียนหัว</UI.P>
                      <Select
                      showSearch
                      style={{ width: '100%' }}
                      loading={truckLoading}
                      allowClear={true}
                      value={mutationVariables?.plateNumber}
                      filterOption={(input, option) => option.props.plateNumber.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      onChange={(e, o) => {
                        if (!e) {
                          onChangeHandler('truckId', { truckId: null, plateNumber: null })
                        } else {
                          onChangeHandler('truckId', { truckId: e, plateNumber: o?.props?.plateNumber })
                        }
                      }}
                      onSearch={e => truckRefetch({ plateNumber: e })}
                      placeholder='พิมพ์เพื่อค้นหา'
                    >
                      {
                        truckData?.TruckList?.lists?.map(v => <Select.Option key={v.id} value={v.id} plateNumber={v.plateNumber}>{v.plateNumber}</Select.Option>)
                      }
                    </Select>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ทะเบียนหาง</UI.P>
                      <Select
                      showSearch
                      style={{ width: '100%' }}
                      loading={trailerLoading}
                      allowClear={true}
                      value={mutationVariables?.trailerPlate}
                      filterOption={(input, option) => option.props.trailerPlate.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      onChange={(e, o) => {
                        if (!e) {
                          onChangeHandler('trailerId', { trailerId: null, trailerPlate: null })
                        } else {
                          onChangeHandler('trailerId', { trailerId: e, trailerPlate: o?.props?.trailerPlate })
                        }
                      }}
                      onSearch={e => trailerRefetch({ trailerPlate: e })}
                      placeholder='พิมพ์เพื่อค้นหา'
                    >
                      {
                        trailerData.TrailerList.lists.map(v => <Select.Option key={v.id} value={v.id} trailerPlate={v.trailerPlate}>{v.trailerPlate}</Select.Option>)
                      }
                    </Select>
                    </UI.Div>
                  </Col>
                </UI.Div>
              </UI.Div>
            }
          </UI.Div>
        </Col>
      )
    }
    case 14:
      return null
    case 15:
      return null
    case 16:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='row'>
            <UI.Div display='flex' flexDirection='column'>
              <UI.P margin='0 8px 16px 0' >{data.props.title.text}</UI.P>
              <UI.P margin='0 8px 16px 0' >{tirePatchStore ? tirePatchStore[data.id] : '-'}</UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, mutationVariables, disabled, initialData, onChangeHandler, tireInfoData, setTireInfoId, setPatchDate, tirePatchStore, setTirePatchStore,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel width='100%' {...data.props} input={{
            disabled,
            defaultValue: initialData[data.id],
            onChange: e => onChangeHandler(data.id, e.target.value),
            onKeyDown: (e) => {
              if (data.id === 'salary' && !checkFloat(e)) {
                e.preventDefault()
              }
            },
            type: data.id === 'salary' ? 'number' : 'text',
            step: data.id === 'salary' ? '0.1' : undefined,
            min: '0',
            ...data.props.input,
          }} />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 3.1: {
      const {
        loading: tireLoading, data: tireData, error: tireError, refetch: tireRefetch,
      } = useQuery(TIRE_SERIAL_NUMBER_LIST)
      if (tireLoading && _.isEmpty(tireData)) return <UI.Loading />
      if (tireError) return <UI.P>{console.log(tireError, 'asxsax')}เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              disabled={disabled}
              style={{ width: '100%' }}
              loading={tireLoading}
              defaultValue={initialData.Serial.serialNumber}
              filterOption={(input, option) => option.props.serialNumber.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
                setTireInfoId(`${e}`)
              }}
              onSearch={e => tireRefetch({ serialNumber: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                tireData.TireSerialNumberList.lists.map(v => <Select.Option key={v.id} value={v.id} serialNumber={v.serialNumber}>{v.serialNumber}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 3.2: {
      const {
        loading: driverLoading, data: driverData, error: driverError, refetch: driverRefetch,
      } = useQuery(DRIVER_LIST)
      if (driverLoading && _.isEmpty(driverData)) return <UI.Loading />
      if (driverError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <Select
              showSearch
              disabled={disabled}
              style={{ width: '100%' }}
              defaultValue={initialData.Driver.fullname}
              loading={driverLoading}
              filterOption={(input, option) => option.props.fullname.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                onChangeHandler(data.id, e)
              }}
              onSearch={e => driverRefetch({ fullname: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                driverData.DriverList.lists.map(v => <Select.Option key={v.id} value={v.id} fullname={v.fullname}>{v.fullname}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    }
    case 3.3: {
      const {
        loading: patchTypeLoading, data: patchTypeData, error: patchTypeError,
      } = useQuery(TIRE_PATCH_TYPE_LIST)
      if (patchTypeLoading && _.isEmpty(patchTypeData)) return <UI.Loading />
      if (patchTypeError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <AutoComplete
              {...data.props}
              disabled={disabled}
              dataSource={patchTypeData.TirePatchLogTypeList.data}
              defaultValue={initialData[data.id]}
              style={{ width: '100%' }}
              onSelect={e => onChangeHandler(data.id, e)}
              onSearch={e => onChangeHandler(data.id, e)}
            />
          </UI.Div>
        </Col>
      )
    }
    case 3.4: {
      const [addTirePatchStoreModal, setAddTirePatchStoreModal] = useState(false)
      const {
        loading: tirePatchStoreLoading, data: tirePatchStoreData, error: tirePatchStoreError, refetch: tirePatchStoreRefetch,
      } = useQuery(GET_TIRE_PATCH_SHOP_LIST)
      if (tirePatchStoreLoading && _.isEmpty(tirePatchStoreData)) return <Col span={data.span} offset={data.offset}><UI.Loading /></Col>
      if (tirePatchStoreError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.Div display='flex'>
              <Select
                showSearch
                style={{ width: '70%' }}
                disabled={disabled}
                loading={tirePatchStoreLoading}
                defaultValue={initialData.TirePatchStore.name}
                filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onSelect={(e) => {
                  onChangeHandler(data.id, e)
                  setTirePatchStore(_.find(tirePatchStoreData.TirePatchStoreList.lists, o => o.id === e))
                }}
                onSearch={e => tirePatchStoreRefetch({ name: e })}
                placeholder='พิมพ์เพื่อค้นหา'
              >
                {
                  tirePatchStoreData.TirePatchStoreList.lists.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
                }
              </Select>
              <UI.Button
                margin='-10px 0 0 16px'
                text={'เพิ่มร้านปะยาง'}
                icon={'fas fa-plus'}
                disabled={disabled}
                onClick={() => setAddTirePatchStoreModal(true)}
              />
            </UI.Div>
            <AddTirePatchStoreModal addTirePatchStoreModal={addTirePatchStoreModal} setAddTirePatchStoreModal={setAddTirePatchStoreModal} />
          </UI.Div>
        </Col>
      )
    }
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 5: {
      const [file, setFile] = useState(!_.isUndefined(initialData[data.id]) && !_.isNull(initialData[data.id]) && initialData[data.id].map(v => (
        {
          name: v.filename,
          url: v.url,
          uid: v.url,
        })))
      const [initialFile, setInitialFile] = useState(initialData[data.id])
      if (!(initialData[data.id] === initialFile)) {
        setFile(file.concat(initialData[data.id].filter(e => !initialFile.includes(e)).map(v => (
          {
            name: v.filename,
            url: v.url,
            uid: v.url,
          }
        ))))
        setInitialFile(initialData[data.id])
      }
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? v : v.originFileObj)))
              setFile(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? v : v.originFileObj)))
            }}
            customRequest={() => null}
            processData={false}
            disabled={disabled}
            fileList={file}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={!_.isUndefined(initialData[data.id]) && !_.isNull(initialData[data.id]) && initialData[data.id].map(v => (
              {
                name: v.filename,
                url: v.url,
                uid: v.url,
              }))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    }
    case 7:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} disabled={disabled} style={{ margin: '0 0 16px' }} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker onChange={(e) => {
              setPatchDate(e)
              onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))
            }} disabled={disabled} defaultValue={moment(initialData[data.id])} style={{ marginBottom: 16 }} />
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          {initialData.status === 'CANCEL'
            && <UI.Div display='flex' flexDirection='column'>
              <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
              <UI.P margin='0 8px 0 0'>{initialData[data.id]}</UI.P>
            </UI.Div>
          }
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.P color={STATUSCOLORSELECTOR(initialData[data.id])} margin='0 8px 0 0'>{STATUSTEXTSELECTOR(initialData[data.id])}</UI.P>
          </UI.Div>
        </Col>
      )
    case 13: {
      const {
        loading: truckLoading, data: truckData, refetch: truckRefetch,
      } = useQuery(GET_TRUCK_LIST)
      const {
        loading: trailerLoading, data: trailerData, error: trailerError, refetch: trailerRefetch,
      } = useQuery(GET_TRAILER_LIST)
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0' bold>{data.label}</UI.P>
            {!_.isEmpty(tireInfoData)
              && <UI.Div>
                <UI.Div display='flex' flexDirection='row'>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ชื่อ</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.inventoryOption.inventory.productName}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ยี่ห้อ</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.inventoryOption.inventory.brand}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ประเภทยาง</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.Tire.TireType.name}</UI.P>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >รุ่น</UI.P>
                      <UI.P margin='0 8px 16px 0' >{tireInfoData.TireSerialNumberInfoForTirePatchLog.inventoryOption.variantName}</UI.P>
                    </UI.Div>
                  </Col>
                </UI.Div>
                <UI.Div display='flex' flexDirection='row'>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ทะเบียนหัว</UI.P>
                      <Select
                      showSearch
                      style={{ width: '100%' }}
                      loading={truckLoading}
                      allowClear={true}
                      disabled={disabled}
                      value={mutationVariables?.plateNumber}
                      filterOption={(input, option) => option.props.plateNumber.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      onChange={(e, o) => {
                        if (!e) {
                          onChangeHandler('truckId', { truckId: null, plateNumber: null })
                        } else {
                          onChangeHandler('truckId', { truckId: e, plateNumber: o?.props?.plateNumber })
                        }
                      }}
                      onSearch={e => truckRefetch({ plateNumber: e })}
                      placeholder='พิมพ์เพื่อค้นหา'
                    >
                      {
                        truckData?.TruckList?.lists?.map(v => <Select.Option key={v.id} value={v.id} plateNumber={v.plateNumber}>{v.plateNumber}</Select.Option>)
                      }
                    </Select>
                    </UI.Div>
                  </Col>
                  <Col span={6} >
                    <UI.Div display='flex' flexDirection='column'>
                      <UI.P margin='0 8px 16px 0' >ทะเบียนหาง</UI.P>
                      <Select
                      showSearch
                      style={{ width: '100%' }}
                      loading={trailerLoading}
                      allowClear={true}
                      disabled={disabled}
                      value={mutationVariables?.trailerPlate}
                      filterOption={(input, option) => option.props.trailerPlate.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      onChange={(e, o) => {
                        if (!e) {
                          onChangeHandler('trailerId', { trailerId: null, trailerPlate: null })
                        } else {
                          onChangeHandler('trailerId', { trailerId: e, trailerPlate: o?.props?.trailerPlate })
                        }
                      }}
                      onSearch={e => trailerRefetch({ trailerPlate: e })}
                      placeholder='พิมพ์เพื่อค้นหา'
                    >
                      {
                        trailerData.TrailerList.lists.map(v => <Select.Option key={v.id} value={v.id} trailerPlate={v.trailerPlate}>{v.trailerPlate}</Select.Option>)
                      }
                    </Select>
                    </UI.Div>
                  </Col>
                </UI.Div>
              </UI.Div>
            }
          </UI.Div>
        </Col>
      )
    }
    case 14:
      if (initialData[data.id]) {
        return (
          <Col span={data.span} offset={data.offset}>
            <UI.Div display='flex' flexDirection='row'>
              <Col span={6} >
                <UI.Div display='flex' flexDirection='column'>
                  <UI.P margin='0 8px 16px 0' >วันที่จ่าย</UI.P>
                  <UI.P margin='0 8px 16px 0' >{moment(initialData[data.id]).format('DD/MM/YYYY')}</UI.P>
                </UI.Div>
              </Col>
            </UI.Div>
          </Col>
        )
      }
      return null
    case 15:
      if (initialData[data.id]) {
        return (
          <Col span={data.span} offset={data.offset}>
            <UI.Div display='flex' flexDirection='row'>
              <Col span={6} >
                <UI.Div display='flex' flexDirection='column'>
                  <UI.P margin='0 8px 16px 0' >ยอดเงิน</UI.P>
                  <UI.P margin='0 8px 16px 0' >{initialData[data.id]} บาท</UI.P>
                </UI.Div>
              </Col>
            </UI.Div>
          </Col>
        )
      }
      return null
    case 16:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='row'>
            <UI.Div display='flex' flexDirection='column'>
              <UI.P margin='0 8px 16px 0' >{data.props.title.text}</UI.P>
              <UI.P margin='0 8px 16px 0' >{tirePatchStore ? tirePatchStore[data.id] : '-'}</UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 17:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 8px 16px 0'>{data.label}</UI.P>
            <UI.P margin='0 8px 0 0'>{initialData[data.id]}</UI.P>
          </UI.Div>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mutationVariables, mode, onChangeHandler, initialData, setTireInfoId, setPatchDate, tireInfoData, tirePatchStore, setTirePatchStore,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} mutationVariables={mutationVariables} onChangeHandler={onChangeHandler} setTireInfoId={setTireInfoId} setPatchDate={setPatchDate} tireInfoData={tireInfoData} tirePatchStore={tirePatchStore} setTirePatchStore={setTirePatchStore} />
    case detailMode.EDIT:
      return <EditMode data={data} mutationVariables={mutationVariables} initialData={initialData} onChangeHandler={onChangeHandler} setTireInfoId={setTireInfoId} setPatchDate={setPatchDate} tireInfoData={tireInfoData} tirePatchStore={tirePatchStore} setTirePatchStore={setTirePatchStore} />
    case detailMode.VIEW:
      return <EditMode data={data} mutationVariables={mutationVariables} disabled={true} initialData={initialData} onChangeHandler={onChangeHandler} setTireInfoId={setTireInfoId} setPatchDate={setPatchDate} tireInfoData={tireInfoData} tirePatchStore={tirePatchStore} setTirePatchStore={setTirePatchStore} />
    default:
      return <p>no mode</p>
  }
}
